// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { change } from 'redux-form'
import { getNestedByString } from 'helpers/reduxFormFunctions'

// nameRoot will either be radios[0] or radios[1]
// site 1 radio or site 2 radio respectively

const removeFavoriteFromRadio = nameRoot => (dispatch, getState) => {
  const {
    form,
    pathDetails,
  } = getState()

  const sourceForm = pathDetails.get('sourceForm')
  const { values } = form[sourceForm]
  const radioData = getNestedByString(values, nameRoot)
  const {
    radioCode: favoriteCode,
    radioFavoriteId,
  } = radioData

  // if there is no favorite assigned to this site's radio, then get outta here.
  if (radioFavoriteId === null) {
    return
  }

  // eg radio code: 123ABC
  // eg radio favorite code: 123ABC-1
  // remove '-1' to revert back to radio code
  const radioCode = favoriteCode.slice(0, favoriteCode.lastIndexOf('-'))

  const radio = {
    ...radioData,
    legacyRadioCode: null,
    radioCode,
    radioFavoriteId: null,
  }
  dispatch(change(sourceForm, nameRoot, radio))
}

export default removeFavoriteFromRadio
